import { fromJS, List } from 'immutable';

import ProfileSection from 'models/ProfileSectionModel';
import { ProfileSectionOrder } from 'enums/profile-section-type';

import { normalizeIds, normalizeModelList } from '../utils/Normalizer';

import { createEntityProfile, entityProfile, updateProfileSection } from './types';

export * from './actions';

const initialState = fromJS({
  byId: {},
  ids: [],
  entityId: false,
  network: { loading: false, error: false },
});

const requestEntityProfileReducer = (state, action) =>
  state.withMutations((s) =>
    s.setIn(['network', 'loading'], true).setIn(['entityId'], action.entityId),
  );

const requestEntityProfileSuccessReducer = (state, action) => {
  const ids = normalizeIds(action.response, 'section');
  const byId = normalizeModelList(action.response, ProfileSection.deserialize, 'section');

  return state.withMutations((s) =>
    s
      .setIn(['network', 'loading'], false)
      .setIn(['network', 'error'], false)
      .setIn(['byId'], byId)
      .setIn(['ids'], List(ProfileSectionOrder.filter((section) => ids.indexOf(section) >= 0))),
  );
};

const requestEntityProfileFailureReducer = (state, action) =>
  state.withMutations((s) =>
    s
      .setIn(['network', 'loading'], false)
      .setIn(['network', 'error'], action.error)
      .setIn(['byId'], {})
      .setIn(['ids'], []),
  );

const requestUpdateProfileSectionReducer = (state, action) =>
  state.withMutations((s) => s.setIn(['byId', action.sectionId, 'network', 'loading'], true));

const requestUpdateProfileSectionSuccessReducer = (state, action) =>
  state.withMutations((s) =>
    s
      .setIn(['byId', action.sectionId, 'data'], action.response)
      .setIn(['byId', action.sectionId, 'completed'], action.response.completed)
      .setIn(['byId', action.sectionId, 'updateRequested'], action.response.updateRequested)
      .setIn(['byId', action.sectionId, 'network', 'loading'], false)
      .setIn(['byId', action.sectionId, 'network', 'error'], false),
  );

const requestUpdateProfileSectionFailureReducer = (state, action) =>
  state.withMutations((s) =>
    s
      .setIn(['byId', action.sectionId, 'network', 'loading'], false)
      .setIn(['byId', action.sectionId, 'network', 'error'], action.error),
  );

export default function fundingSearchReducer(state = initialState, action) {
  switch (action.type) {
    case createEntityProfile.request:
      return requestEntityProfileReducer(state, action);
    case createEntityProfile.success:
      return requestEntityProfileSuccessReducer(state, action);
    case createEntityProfile.failure:
      return requestEntityProfileFailureReducer(state, action);

    case entityProfile.request:
      return requestEntityProfileReducer(state, action);
    case entityProfile.success:
      return requestEntityProfileSuccessReducer(state, action);
    case entityProfile.failure:
      return requestEntityProfileFailureReducer(state, action);

    case updateProfileSection.request:
      return requestUpdateProfileSectionReducer(state, action);
    case updateProfileSection.success:
      return requestUpdateProfileSectionSuccessReducer(state, action);
    case updateProfileSection.failure:
      return requestUpdateProfileSectionFailureReducer(state, action);

    default:
      return state;
  }
}
